/**
 * Small generation fence for deep links. Multiple Android intents or browser
 * navigations can arrive while a previous verification request is in flight;
 * only the latest request may apply tokens or publish UI.
 */
export function createLatestVerificationLinkRequestGate() {
  let generation = 0;
  let activeToken = null;

  return {
    start(token) {
      const cleanToken = String(token || "").trim();
      if (!cleanToken || activeToken === cleanToken) return null;
      generation += 1;
      activeToken = cleanToken;
      return Object.freeze({ generation, token: cleanToken });
    },

    isLatest(request) {
      return Boolean(request && request.generation === generation && request.token === activeToken);
    },

    finish(request) {
      if (!this.isLatest(request)) return false;
      activeToken = null;
      return true;
    },

    cancelAll() {
      generation += 1;
      activeToken = null;
    },
  };
}
